/**
 * Check buttons list component script
 */
export const MyPeople = (function () {

  var contactSearchList = [];

  var csrfHeaders = function () {
    return {
      "x-csrf-token":
        '{"csrf_name":"' +
        $("#csrf_name").val() +
        '","csrf_value":"' +
        $("#csrf_value").val() +
        '"}',
    };
  };

  var regOpenClicks = function () {
    var key = $(".my-people-relationship-list-items").attr("data-attr-key");

    //edit-open mode
    $("button.btn-life-people")
      .off("click")
      .on("click", function () {
        var itemKey = $(this).attr("data-attr-item-key");
        key = $(this).attr("data-attr-key");
        var mode = $(this).attr("data-attr-mode");
        var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');
        contactSearchList = [];
 
        var selectExisting = $('#myPeopleContainer-'+key).attr('data-select-existing');
        if(selectExisting){

          $("#myPeopleModal-" +key +" .choose-existing").addClass('d-none');
          $("#myPeopleModal-" +key +" .my-people-unlink").removeClass('d-none');
          
          $.get(
            MaMFormHandler.getBaseUrl()+"/get-table/"+componentMode+"?key=" + key + "&records=all",
            function (res) {
  
  
                var addRowClass = 'col-md-12';
                var addPersonClass = 'btn';
  
                $("#myPeopleModal-" +key +" .existing-"+mode+"-list").html('')
                
                $.each(res, function (i, val) {
  
                  var contactTitle = val.first_name + " " + val.surname;
                  if(mode == 'contact'){
                    contactTitle = val.organisation_name;
                  }

                  if(mode == 'contact' && val.contact_type == 'person'){
                    return;
                  }
                  if(mode == 'people' && val.contact_type == 'organisation'){
                    return;
                  }
                  
                  contactSearchList.push(val);
                  
  
                });
                
  
            });
  
            $('.is-existing-added').off('click').on('click', function(){
              $("#myPeopleModal-" +key +" .unlink-existing").removeClass('d-none');
            }); 
        }

        $("#myPeopleModal-" + key +" .people-form .add-existing-container").addClass('d-none');
        $("#myPeopleModal-" + key +" .contact-form .add-existing-container").addClass('d-none');


        //clean out the modal and its inputs - editing a new person
        $("#myPeopleModal-" + key + " .update-insert").html("Update ");
        $("#myPeopleModal-" + key + " .item-key").val(itemKey);
        $("#myPeopleModal-" + key + " input").removeClass("noborder");
        $("#myPeopleModal-" + key + " .input-errors").html("");
        $("#file-dropper-droparea").css("background-image", "unset");
        $(
          "#myPeopleModal-" +
            key +
            " .my-people-relationship-list-items .person-click-row"
        ).remove();
        $("#myPeopleModal-" + key + " .person-click-row").remove();
        $("#myPeopleModal-" + key + " input.load-people").remove();
        $("#myPeopleModal-" + key + " .modal-content").animate(
          { scrollTop: 0 },
          200
        );
        $("#myPeopleModal-" + key + " .my-people-delete").show();
        $("#myPeopleModal-" + key + " .form-append").remove();

        $(
          "#myPeopleModal-" +
            key +
            ' .check-buttons-multi input[type="checkbox"]'
        ).each(function () {
          if ($(this).attr("checked") == "checked") {
            $(this).trigger("click");
          }
        });

        if(mode == 'contact'){
          $("#myPeopleModal-" + key + ' .contact-form').show();
          $("#myPeopleModal-" + key + ' .people-form').hide();
          $("#myPeopleModal-" + key + " .modal-mode").val('contact');
        }else{
          $("#myPeopleModal-" + key + ' .people-form').show();
          $("#myPeopleModal-" + key + ' .contact-form').hide();
          $("#myPeopleModal-" + key + " .modal-mode").val('people');
        }

        //get a 'person', and insert all its values into the existing modal form for editing
        $.get(
          MaMFormHandler.getBaseUrl()+"/get-table/"+componentMode+"?key=" + key + "&row=" + itemKey,
          function (res) {
            $.each(res, function (i, val) {
              
              var activeElementRef = "#myPeopleModal-" + key + ' [name="' + key + "[" + i + ']"]';
              var activeElementRefMulti = "#myPeopleModal-" + key + ' [name="' + key + "[" + i + '][]"]';

              if(typeof val == "object"){
                $.each(val, function (ii, valx) {
                  $("#myPeopleModal-" + key + ' input[name="'+key+'[' + i + '][' + ii + ']"]').val(valx);
                });
              }
              var activeElement = $(activeElementRef);
              if ($(activeElement).attr("type") != "radio"){
                  $(activeElement).val(val);
                  if(val){
                    $(activeElement).addClass("noborder");
                  }
              }
              

              if (
                $(activeElementRefMulti).attr("type") == "checkbox" //&& val == "true"
              ) {
                
                if(typeof val == "object"){
                  $.each(val, function (ii, valx) {
                    $(activeElementRefMulti+"[value='"+valx+"']").trigger("click");
                  });
                }
              }

              if (
                $(activeElement).attr("type") == "radio" &&
                val == $(activeElementRef+'[value="'+val+'"]').val()
              ) {
                $(activeElementRef+'[value="'+val+'"]').trigger("click");
              }

              if (i == "profile_picture") {
                $(".file-dropper-droparea[key=" + i + "]").css(
                  "background-image",
                  "url('data:image/png;base64," + val + "')"
                );
              } else if (
                $('.nested_people_components[value="'+i+'"][data-attr-key="'+key+'"]').length
              ) {
                $("#myPeopleContainer-" + i + " > input.load-people").remove();

                $(val).each(function (idx, person) {
                  var personId = person.id;
                  $("#myPeopleContainer-" + i).append(
                    '<input class="form-append load-people" type="hidden" name="' +
                      key +
                      "[" +
                      i + 
                      '][my_people][]" value="' +
                      personId +
                      '" data-attr-peopleid="' +
                      personId +
                      '" data-attr-key="' +
                      key +
                      '"/>'
                  );
                });
                populateTableKey(i);
              }
            });

            $("#myPeopleModal-" + key + " .modal-content").animate(
              { scrollTop: 0 },
              200
            );

            $("#myPeopleModal-" + key + " .my-people-delete").attr(
              "data-attr-ref",
              itemKey
            );

            $("#myPeopleModal-" + key + " .my-people-unlink").attr(
              "data-attr-ref",
              itemKey
            );
          },
          "json"
        );
      });
  };

  var customAddTo = function(key, insertId, inputName){

    //custom append to, usage in my-medications for example.
    //basically populates the added id's somewhere else for use in other components
    if($('#myPeopleContainer-'+key).attr('data-attr-external-input') != '1'){
      return false;
    }

    $('#myPeopleContainer-'+key).parent().append(
      '<input type="hidden" class="custom-append-to" name="'+inputName+'" value="'+insertId +'" data-attr-key="'+key+'"/>'
    );
   
    return false;
  };

  var customAddToRemove = function(key, insertId){
    
    if($('#myPeopleContainer-'+key).attr('data-attr-external-input') != '1'){
      return false;
    }
    $('.custom-append-to[data-attr-key="'+key+'"][value="'+insertId +'"]').remove();
    
    return false;
  };

  //function for saving the list of 'people' ids in the my-people component question
  var addListToComponent = function (key) {
    var addingIds = "";
    $("#myPeopleContainer-" + key + " .btn-life-people").each(function () {
      addingIds = addingIds + $(this).attr("data-attr-item-key") + ",";
    });

    var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');

    var formData = new FormData();
    
    formData.append("key", key);
    
    if(componentMode == 'contact'){
      formData.append("mode", "my-contacts-submit");
      formData.append("my_contacts[]", addingIds);
    }else{
      formData.append("mode", "my-people-submit");
      formData.append("my_people[]", addingIds);
    }

    $.ajax({
      type: "POST",
      url: window.location.href,
      data: formData,
      processData: false,
      contentType: false,
      dataType: "json",
      headers: csrfHeaders(),
      success: function (res, textStatus, jqXHR) {
        return false;
      },
      error: function (res, textStatus, jqXHR) {
        return false;
      },
    });
  };

  var clearTableKey = function(key){
    $("#myPeopleContainer-" + key + " .person-click-row").remove();

    $(".custom-append-to[data-attr-key='"+key+"']").remove();
    $("#myPeopleContainer-" + key + " > .load-people").remove();

    $("#myPeopleContainer-" + key + " .my-people-add").removeClass('d-none');

  };

  //populate the referenced (by key) my-people list
  var populateTableKey = function (key) {
    var loadPeople = "";
    var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');
    var smallMode = $("#myPeopleContainer-" + key).hasClass('my-people-small-mode');
 
    $("#myPeopleContainer-" + key + " > .load-people").each(function () {
      if (loadPeople) {
        loadPeople = loadPeople + "," + $(this).attr("data-attr-peopleid");
      } else {
        loadPeople = $(this).attr("data-attr-peopleid");
      }
    });

    $("#myPeopleContainer-" + key + "").attr('data-attr-record-count', 0);

    if(loadPeople == ''){
      return false;
    }

    $.get(
      MaMFormHandler.getBaseUrl()+"/get-table/"+componentMode+"?key=" + key + "&records=" + loadPeople, //people=1,2,3
      function (res) {
        $("#myPeopleContainer-" + key + " .person-click-row").remove();
        var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));

        if(maxRecords && res.length >= maxRecords){
          $("#myPeopleContainer-" + key + " .my-people-add").addClass('d-none');
        }else{
          $("#myPeopleContainer-" + key + " .my-people-add").removeClass('d-none');
        }

        $("#myPeopleContainer-" + key + "").attr('data-attr-record-count', res.length);

        $.each(res, function (i, val) {

          if(val.contact_type == 'organisation'){
            var buttonTitle = val.organisation_name;
            var contactType = 'contact';
          } else { 
            var buttonTitle = val.first_name + " " + val.surname;
            var contactType = 'people';
          }

          var addRowClass = 'col-md-12';
          var addPersonClass = 'btn';
          if(smallMode){
            addRowClass = 'col-md-6';
            addPersonClass = 'btn btn-sm';
            if(maxRecords > 1 || isNaN(maxRecords)){
              addRowClass = 'ml-1 is-existing-added';
            }
          }

          $(
            '.my-people-relationship-list-items[data-attr-key="' + key + '"]'
          ).append(
            '<div class="'+addRowClass+' person-click-row">' +
              '<div class="form-group">' +
              '<button type="button" class="'+addPersonClass+' btn-primary btn-life-people" data-toggle="modal" data-attr-key="' +
              key +
              '" data-attr-item-key="' +
              val.id +
              '"' +
              'data-target="#myPeopleModal-' +
              key +
              '"'+
              'data-attr-mode="'+contactType+'">' +
              buttonTitle +
              "</button>" +
              "</div>" +
              "</div>"
          );
          $(
            '.my-people-relationship-list-items[data-attr-key="' + key + '"]'
          ).removeClass("populate-me");

          customAddTo(key, val.id, key +'[my_contacts][]');
        });
        regOpenClicks();
      },
      "json"
    );
  };

  var initsaveExistingListener = function(){
    $(".my-people-save-existing").off("click").on("click", function () {
      var key = $(this).attr("data-attr-key");
      var itemKey = $(this).attr("data-attr-item-key");
  
      var mode = $("#myPeopleModal-" + key + " .modal-mode").val(); 
      var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');
      
      var smallMode = $("#myPeopleContainer-" + key).hasClass('my-people-small-mode');
  
      var contactTitle = $(this).html();

      var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));
      var currentRecords = $("#myPeopleContainer-" + key + " .btn-life-people").length;


      var addRowClass = 'col-md-6';
      var addPersonClass = 'btn btn-sm';
      if(maxRecords > 1 || isNaN(maxRecords)){
        addRowClass = 'ml-1 is-existing-added';
      }

      if(maxRecords && currentRecords >= maxRecords){
        if(smallMode){ 
          $("#myPeopleContainer-" + key).find('.my-people-relationship-list-items .person-click-row').remove();
        }
      }

      
       
      //close the modal and append
      $(
        "#myPeopleContainer-" +
          key +
          " .my-people-relationship-list-items"
      ).append(
        '<div class="'+addRowClass+' person-click-row">' +
          '<div class="form-group">' +
          '<button type="button" class="'+addPersonClass+' btn-primary btn-life-people" data-toggle="modal" data-attr-key="' +
          key +
          '" data-attr-item-key="' +
          itemKey +
          '" data-target="#myPeopleModal-' +
          key +
          '" data-attr-mode="'+mode+'">' +
          contactTitle +
          "</button>" +
          "</div>" +
          "</div>"
      );
      $("#myPeopleModal-" + key).modal("hide");

      customAddTo(key, itemKey, key +'[my_contacts][]');

      var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));
      var currentRecords = $("#myPeopleContainer-" + key + " .btn-life-people").length;

      if(maxRecords && currentRecords >= maxRecords){
        $("#myPeopleContainer-" + key + " .my-people-add").addClass('d-none');
      }else{
        $("#myPeopleContainer-" + key + " .my-people-add").removeClass('d-none');
      }

      regOpenClicks();
      return false;
    });
  }; 


  var init = function () {

    if (typeof MyPeople.baseURL === 'undefined') {
      MyPeople.baseURL = '';
    }

    //grab all the on-screen my-people components and populate them
    $(".my-people-relationship-list-items.populate-me").each(function () {
      var key = $(this).attr("data-attr-key");
      populateTableKey(key);
    });

    //activate the add new record mode of the modal, and clean out all the values
    $(".my-people-add").on("click", function () {
      var key = $(this).attr("data-attr-key");
      var mode = $(this).attr("data-attr-mode");
      var maxRecords = parseInt($(this).attr("data-attr-max"));
      var countRecords = parseInt($(".my-people-relationship-list-items[data-attr-key='"+key+"'] .btn-life-people").length);
      var selectExisting = $('#myPeopleContainer-'+key).attr('data-select-existing');
      var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');
      contactSearchList = [];
      
      if(maxRecords && countRecords >= maxRecords){
        alert("You can only add "+maxRecords+"");
        return false;
      }

      var modalTitle = 'Add People';
      if(mode == 'contact'){
        var modalTitle = 'Add Organisation';
      }
      $("#myPeopleModal-" + key + " .update-insert").html(modalTitle);

      $("#myPeopleModal-" + key + " .input-errors").html("");
      $("#myPeopleModal-" + key + " :input:not([type=checkbox]):not([type=radio])").each(function () {
        $(this).val("");
      });

      $("#myPeopleModal-" + key + " .item-key").val("new");
      $("#myPeopleModal-" + key + " .modal-mode").val(mode); 
      

      $("#myPeopleModal-" + key + " .my-people-delete").hide();
      $("#myPeopleModal-" + key + " .modal-content").animate(
        { scrollTop: 0 },
        200
      );
      $("#myPeopleModal-" + key + " .person-click-row").remove();
      $("#myPeopleModal-" + key + " input.load-people").remove();
      $("#myPeopleModal-" + key + " .form-append").remove();

      $(
        "#myPeopleModal-" + key + ' .check-buttons-multi input[type="checkbox"]'
      ).each(function () {
        if ($(this).attr("checked") == "checked") {
          $(this).trigger("click");
        }
      }); 

      $("#myPeopleModal-" + key + ' .table-radio-select input[type="radio"]:checked').prop('checked', false);

      if(mode == 'contact'){
        $("#myPeopleModal-" + key + ' .contact-form').show();
        $("#myPeopleModal-" + key + ' .people-form').hide();
      }else{
        $("#myPeopleModal-" + key + ' .people-form').show();
        $("#myPeopleModal-" + key + ' .contact-form').hide();
      }

      $("#myPeopleModal-" + key +" .choose-existing").addClass('d-none');
      $("#myPeopleModal-" + key +" .my-people-unlink").addClass('d-none');

      //selectExisting
      if(selectExisting){
        
        $("#myPeopleModal-" + key +" .people-form .add-existing-container").addClass('d-none');
        $("#myPeopleModal-" + key +" .contact-form .add-existing-container").addClass('d-none');
        $("#myPeopleModal-" + key +" .choose-existing").removeClass('d-none');

        $.get(
          MaMFormHandler.getBaseUrl()+"/get-table/"+componentMode+"?key=" + key + "&records=all",
          function (res) {

              var addRowClass = 'col-md-12';
              var addPersonClass = 'btn';

              $("#myPeopleModal-" +key +" .existing-"+mode+"-list").html('')
              
              $.each(res, function (i, val) {

                var contactTitle = val.first_name + " " + val.surname;
                if(mode == 'contact'){
                  contactTitle = val.organisation_name;
                }
                if(mode == 'contact' && val.contact_type == 'person'){
                  return;
                }
                if(mode == 'people' && val.contact_type == 'organisation'){
                  return;
                }

                contactSearchList.push(val);
                
              });
              
              

          });

          
      }

    });

    //close modal
    $(".my-people-close").on("click", function () {
      var key = $(this).attr("data-attr-key");
      $("#myPeopleModal-" + key).modal("hide");
    });




    //save modal mode
    $(".my-people-save").on("click", function () {

      //build and submit the payload to create/update the person. Handle any validation errors,
      //and if its a new record - populate the underlying component with the new 'person' in the list
      var key = $(this).attr("data-attr-key");
      var itemKey = $("#myPeopleModal-" + key + " .item-key").val();

      var mode = $("#myPeopleModal-" + key + " .modal-mode").val(); 
      var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');
      
      var smallMode = $("#myPeopleContainer-" + key).hasClass('my-people-small-mode');
      var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));
    
      var payload = {};

      $("#myPeopleModal-" + key  + " ." + mode + "-form :input").each(function () {
        
        if (typeof $(this).attr("name") != "undefined") {
          if (
            $(this).attr("data-attr-key") == key ||
            $(this).attr("name") == "csrf_name" ||
            $(this).attr("name") == "csrf_value"
          ) {
            
            if (
              $(
                "#myPeopleModal-" +
                  key + " ." + mode +"-form :input[name='" +
                  $(this).attr("name") +
                  "']"
              ).length > 1
              && 
              $(this).attr("type") != "radio" 
              && 
              $(this).attr("type") != "checkbox"
            ) {
              if (typeof payload[$(this).attr("name")] == "undefined") {
                payload[$(this).attr("name")] = [];
              }
              
              payload[$(this).attr("name")].push($(this).val());
            } else if ($(this).attr("type") == "checkbox") {

              if (typeof payload[$(this).attr("name")] == "undefined") {
                payload[$(this).attr("name")] = [];
              }

              if ($(this).attr("checked") == "checked") {
                payload[$(this).attr("name")].push($(this).val());
              }

            } else if ($(this).attr("type") == "radio") {
              if ($(this).prop("checked") == true) {
                payload[$(this).attr("name")] = $(this).attr("value");
              }
            } else {
              payload[$(this).attr("name")] = $(this).val();
            }
          }
        }
      });

      //console.log(payload);return false;
      
      var url = MaMFormHandler.getBaseUrl()+"/add-table-row/"+componentMode;
      if (itemKey != "new") {
        url = MaMFormHandler.getBaseUrl()+"/update-table-row/"+componentMode;
      }

      $.post({
        url: url+"?mode="+mode+"&key=" + key + "&item-key=" + itemKey,
        data: payload,
        headers: csrfHeaders(),
        success: function (res) {
          if (!res.success) {
            var message = res.message.split(": ");
            var errorField = message[0];
            var errorMessage = message[1];

            $("#myPeopleModal-" + key + " ." + mode + "-form .input-errors").html("");
            $("#myPeopleModal-" + key + " ." + mode + "-form .input-error-" + errorField).html(
              errorMessage
            );
            
            $('.' + mode + '-form [name="' + key + "[" + errorField + ']"]')[0].scrollIntoView({
              behavior: "smooth",
              block: "start", // or "end"
            });

            return;
          } else {
            if (itemKey == "new") {

              var contactTitle = payload[key + `[first_name]`] + " " + payload[key + `[surname]`];
              if(mode == 'contact'){
                contactTitle = payload[key + `[organisation_name]`];
              }
              var addRowClass = 'col-md-12';
              var addPersonClass = 'btn';
              if(smallMode){
                addRowClass = 'col-md-6';
                addPersonClass = 'btn btn-sm';
                if(maxRecords > 1 || isNaN(maxRecords)){
                  addRowClass = 'ml-1 is-existing-added';
                }
              }
              //close the modal and append
              $(
                "#myPeopleContainer-" +
                  key +
                  " .my-people-relationship-list-items"
              ).append(
                '<div class="'+addRowClass+' person-click-row">' +
                  '<div class="form-group">' +
                  '<button type="button" class="'+addPersonClass+' btn-primary btn-life-people" data-toggle="modal" data-attr-key="' +
                  key +
                  '" data-attr-item-key="' +
                  res.response_data.last_insert_id +
                  '" data-target="#myPeopleModal-' +
                  key +
                  '" data-attr-mode="'+mode+'">' +
                  contactTitle +
                  "</button>" +
                  "</div>" +
                  "</div>"
              );
              $("#myPeopleModal-" + key).modal("hide");

              if (
                $("#myPeopleContainer-" + key).closest(".my-people-modal")
                  .length
              ) {
                var parentKey = $("#myPeopleContainer-" + key)
                  .closest(".my-people-modal")
                  .attr("data-attr-key");

                $("#myPeopleModal-" + parentKey+" ." + mode + "-form").append(
                  '<input class="form-append" type="hidden" name="' +
                    parentKey +
                    "[" +
                    key +
                    '][my_people][]" value="' +
                    res.response_data.last_insert_id +
                    '" data-attr-key="' +
                    parentKey +
                    '"/>'
                );
              } else {
                addListToComponent(key);
                customAddTo(key, res.response_data.last_insert_id, key +'[my_contacts][]');
              }

              var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));
              var currentRecords = $("#myPeopleContainer-" + key + " .btn-life-people").length;

              if(maxRecords && currentRecords >= maxRecords){
                $("#myPeopleContainer-" + key + " .my-people-add").addClass('d-none');
              }else{
                $("#myPeopleContainer-" + key + " .my-people-add").removeClass('d-none');
              }

              regOpenClicks();
            } else {


              var contactTitle = payload[key + `[first_name]`] + " " + payload[key + `[surname]`];
              if(mode == 'contact'){
                contactTitle = payload[key + `[organisation_name]`];
              }
              
              
              $(
                "#myPeopleContainer-" +
                  key +
                  " .my-people-relationship-list-items"
              )
                .find('[data-attr-item-key="' + itemKey + '"]')
                .html(contactTitle);
              $("#myPeopleModal-" + key).modal("hide");
              regOpenClicks();
            }
          }
        },
        dataType: "json",
      });
    });


    //delete functionality, and remove the person row afterwards
    $(".my-people-delete").on("click", function () {

      var key = $(this).attr("data-attr-key");
      var itemKey = $(this).attr("data-attr-ref");
      var componentMode = $(".my-people-relationship-list-items[data-attr-key='"+key+"']").attr('data-attr-mode');
      var modalMode = $("#myPeopleModal-"+key).find('.modal-mode').val();
      var url = MaMFormHandler.getBaseUrl()+"/delete-table-row?id=" + itemKey+"&mode="+componentMode;

      var confirmMessage = "Delete this person, are you sure?";
      if(modalMode == "contact"){
        confirmMessage = "Delete this organisation, are you sure?";
      }
      if (!confirm(confirmMessage)) {
        return false;
      }

      $.post({
        url: url,
        headers: csrfHeaders(),
        success: function (res) {
          $("#myPeopleModal-" + key).modal("hide");
          $("#myPeopleContainer-" + key).modal("hide");
          $('.btn-life-people[data-attr-item-key="' + itemKey + '"]')
            .closest(".person-click-row")
            .remove();
            customAddToRemove(key, itemKey);

            var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));
            var currentRecords = $("#myPeopleContainer-" + key + " .btn-life-people").length;

            if(maxRecords && currentRecords >= maxRecords){
              $("#myPeopleContainer-" + key + " .my-people-add").addClass('d-none');
            }else{
              $("#myPeopleContainer-" + key + " .my-people-add").removeClass('d-none');
            }
          regOpenClicks();
        },
        dataType: "json",
      });
    });

    $(".my-people-unlink").on("click", function () {

      var key = $(this).attr("data-attr-key");
      var itemKey = $(this).attr("data-attr-ref");
      var maxRecords = parseInt($("#myPeopleContainer-" + key + "").attr('data-attr-max'));
      

      $('.btn-life-people[data-attr-item-key="'+itemKey+'"]').closest('.person-click-row').remove();

      var currentRecords = $("#myPeopleContainer-" + key + " .btn-life-people").length;
      customAddToRemove(key, itemKey);
      $("#myPeopleModal-" + key).modal("hide");

      if(parseInt(currentRecords) < parseInt(maxRecords)){
        $("#myPeopleContainer-" + key + " .my-people-add").removeClass('d-none');
      }
    });

    $('.close-choose-existing').on("click", function(){
      $(this).closest('.add-existing-container').addClass('d-none');
      return false;
    });

    $('.choose-existing').on("click", function(){
      
      var key = $(this).attr('data-attr-key');
      var mode = $("#myPeopleModal-" + key + " .modal-mode").val();

      //init a filter populating the div on the fly
      if(mode == 'people'){
        $("#myPeopleModal-" + key +" .people-form .add-existing-container").removeClass('d-none');
      }else{
        $("#myPeopleModal-" + key +" .contact-form .add-existing-container").removeClass('d-none');
      }

      $('.contacts-search-input, .people-search-input').off('keyup').on('keyup', function(){

        var searchValue = $(this).val();
        var searchValueLength = searchValue.length;
        var key = $(this).closest('.my-people-modal').attr('data-attr-key');

        if (searchValueLength < 1) {
          //clear search list
          $(".existing-"+mode+"-list").html('');
          return;
        }

        $(".existing-"+mode+"-list").html('');

        var addRowClass = 'col-md-12';
        var addPersonClass = 'btn';

        contactSearchList.forEach(function(val){

          var contactTitle = val.first_name + " " + val.surname;
          if(mode == 'contact'){
            contactTitle = val.organisation_name;
          }

          if (
            contactTitle.toLowerCase().includes(searchValue.toLowerCase())
          ) {

            $( 
              "#myPeopleModal-" +
                key +
                " .existing-"+mode+"-list"
            ).append(
              '<div class="'+addRowClass+' person-click-row">' +
                '<div class="form-group">' +
                '<button type="button" class="'+addPersonClass+' btn-primary btn-life-people my-people-save-existing" data-attr-key="' +
                key +
                '" data-attr-item-key="' +
                val.id +
                '" data-target="#myPeopleModal-' +
                key +
                '" data-attr-mode="'+mode+'">' +
                contactTitle +
                "</button>" +
                "</div>" +
                "</div>"
            );

          }

        });
        initsaveExistingListener();

      });

      return false;

    });

  };

  return {
    init: init,
    populateTableKey: populateTableKey,
    clearTableKey: clearTableKey
  };
})();
